export default "__VITE_ASSET__vP4p$q_h__"